import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';
import VoiceAgentsIndex from './voiceAgents/Index.vue';
import VoiceAgentEdit from './voiceAgents/Edit.vue';
import VoiceAgentFlowsIndex from './voiceAgents/flows/Index.vue';
import VoiceAgentGuardrailsIndex from './voiceAgents/guardrails/Index.vue';
import VoiceAgentPlayground from './voiceAgents/playground/Index.vue';
import VoiceAgentActionsIndex from './voiceAgents/actions/Index.vue';
import FlowsIndex from './flows/Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/aivoice/voice-agents'),
    component: VoiceAgentsIndex,
    name: 'aivoice_voice_agents_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/aivoice/voice-agents/:voiceAgentId'),
    component: VoiceAgentEdit,
    name: 'aivoice_voice_agents_edit',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/aivoice/voice-agents/:voiceAgentId/flows'
    ),
    component: VoiceAgentFlowsIndex,
    name: 'aivoice_voice_agents_flows_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/aivoice/voice-agents/:voiceAgentId/guardrails'
    ),
    component: VoiceAgentGuardrailsIndex,
    name: 'aivoice_voice_agents_guardrails_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/aivoice/voice-agents/:voiceAgentId/playground'
    ),
    component: VoiceAgentPlayground,
    name: 'aivoice_voice_agents_playground',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/aivoice/flows'),
    component: FlowsIndex,
    name: 'aivoice_flows_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/aivoice/actions'),
    component: VoiceAgentActionsIndex,
    name: 'aivoice_actions_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
];
